import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { TodosContentService } from '../services/my_todos_content_service';

angular
  .module('data-ng-todos')
  .factory(
    'loadAllPathStatusCommand',
    function loadAllPathStatusCommandDefinition(
      $q: ng.IQService,
      TaskStatusEnum: any,
      defineCommand: IDefineCommand,
      loadPathTasksCommand: ICommand,
      clearPathDatastoresCommand: ICommand,
      ngTodosContentService: TodosContentService,
      $state: ng.ui.IStateService,
      TodoFilterEnum: any
    ): void {
      return defineCommand(
        'loadAllPathStatusCommand',
        function loadAllPathStatusCommand(deferred: ng.IDeferred<any>, dateRange: any): any {
          $q.all({
            clearPath: clearPathDatastoresCommand(),
            todos: loadPathTasksCommand(dateRange)
          })
            .then(({ clearPath, todos, todosCompleted, todosDismissed, todosOverdue }) => {
              const filterBy = $state.params.filterBy || 'all';
              const activeFilter = _.find(TodoFilterEnum.__keys__, (filter: any) => filter.stateParam === filterBy);
              ngTodosContentService.initialize(activeFilter);
              $q.all({
                todosCompleted: loadPathTasksCommand(dateRange, TaskStatusEnum.COMPLETED),
                todosDismissed: loadPathTasksCommand(dateRange, TaskStatusEnum.DISMISSED),
                todosOverdue: loadPathTasksCommand(dateRange, TaskStatusEnum.OVERDUE)
              }).finally(() => {
                deferred.resolve();
              });
            })
            .catch(() => {
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/load_all_path_status_command.ts